import { useEffect, useState } from 'react';
import { settingsApi } from '../api/settings_api';
import { useAuthStore } from '../stores/root_store';
import type { AccountSummary } from '../types';

export interface UseAccountSummaryReturn {
  /** null while loading, on error, or for assistants (who have no task plan) */
  summary: AccountSummary | null;
  /** true once the summary is loaded and the client has no tasks left on a limited plan */
  outOfTasks: boolean;
}

export function useAccountSummary(): UseAccountSummaryReturn {
  const authStore = useAuthStore();
  const isAssistant = authStore.isAssistant;
  const [summary, setSummary] = useState<AccountSummary | null>(null);

  useEffect(() => {
    if (isAssistant) {
      setSummary(null);
      return;
    }
    let cancelled = false;
    settingsApi
      .getAccountSummary()
      .then((s) => {
        if (!cancelled) setSummary(s);
      })
      .catch(() => {
        // Leave the summary empty: never block New Request on a failed lookup
        if (!cancelled) setSummary(null);
      });
    return () => {
      cancelled = true;
    };
  }, [isAssistant]);

  const outOfTasks = !!summary && !summary.is_unlimited && summary.tasks_remaining <= 0;
  return { summary, outOfTasks };
}
